import LockSvg from '@assets/images/svg/lock.svg';
import React from 'react';
import { View } from 'react-native';

export interface LockIconProps {
  size?: number;
  color?: string;
}

/** Lock icon (Figma overlay Login button). Default stroke matches source SVG. */
export function LockIcon({ size = 24, color = '#333333' }: Readonly<LockIconProps>) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <LockSvg width={size} height={size} color={color} />
    </View>
  );
}

export default LockIcon;
